import React, { useEffect, useState } from "react";
import AvatarGroup from "@material-ui/lab/AvatarGroup";
import { Avatar, Button, Divider, Grid, makeStyles, Typography } from "@material-ui/core";
import { toast } from "react-toastify";

import { i18n } from "../../translate/i18n";
import api from "../../services/api";
import MultiVCardModal from "../MultiVCardModal";
import toastError from "../../errors/toastError";
import truncateString from "../../utils/truncateString";

import JidUtils from "../../utils/classes/JidUtils";

const useStyles = makeStyles((theme) => ({
  multiVCardContainer: {
    minWidth: "250px",
  },

  multiVCardInfo: {
    color: theme.palette.secondary.ackCheck,
    userSelect: "none",
    marginTop: "12px",
    marginLeft: "10px",
    cursor: "pointer",
    "&:hover": { textDecoration: "underline", },
  },
}));

const MultiVcardPreview = ({ contacts, enableStartChat=true }) => {
  //  ***************
  //  ** Variables **
  //  ***************
  const classes = useStyles();
  const truncateThreshold = 15;

  const [contactsList, setContactsList] = useState([
    { name: "-", number: "", profilePicUrl: "" }
    , { name: "-", number: "", profilePicUrl: "" }
    , { name: "-", number: "", profilePicUrl: "" }
  ]);

  const [arePhoneNumbersValid, setArePhoneNumbersValid] = useState(Array.from({ length: contacts.length }, () => false));
  const [multiVCardModalOpen, setMultiVCardModalOpen] = useState(false);



  //  *****************
  //  ** Use Effects **
  //  *****************
  useEffect(() => {
    const delayDebounceFN = setTimeout(() => {
      const fetchContacts = async () => {
        try {
          const insertedContacts = [];

          for (let index = 0; index < contacts.length; index += 1) {
            if (!contacts[index].number) {
              const contactObject = { name: contacts[index].name, number: i18n.t("vCard.phoneNumberNotAvailable"), email: "" };
              insertedContacts.push(contactObject);

              setArePhoneNumbersValid(previousValue => {
                const newValue = [...previousValue];
                newValue[index] = false;
                return newValue;
              });

              return;
            }

            const contactObject = { name: contacts[index].name, number: JidUtils.formatJidToVCards(contacts[index].number), email: "" };
            const { data } = await api.post("/contactVCard", contactObject);

            setArePhoneNumbersValid(previousValue => {
              const newValue = [...previousValue];
              newValue[index] = data.success;
              return newValue;
            });

            if (data.success) insertedContacts.push(data.contact);
            else toast.info(i18n.t(data.message));
          }

          setContactsList(insertedContacts);
        }
        catch (exception) {
          console.log("Multi VCard Preview Use Effect Exception:", exception);
          toastError(exception);
        }
      };

      fetchContacts();
    }, 500);

    return () => clearTimeout(delayDebounceFN);
  }, [contacts, contactsList]);



  //  ***************
  //  ** Functions **
  //  ***************
  const handleOpenMultiVCardModal = () => {
    setMultiVCardModalOpen(true);
  };

  const handleCloseMultiVCardModal = () => {
    setMultiVCardModalOpen(false);
  };

  

  //  ************
  //  ** Return **
  //  ************
  return (
    <div className={classes.multiVCardContainer}>
      <MultiVCardModal
        open={multiVCardModalOpen}
        onClose={handleCloseMultiVCardModal}
        contactsList={contactsList}
        enableStartChat={enableStartChat}
        arePhoneNumbersValid={arePhoneNumbersValid}
      />

      <Grid container spacing={1}>
        <Grid item xs={12}>
          <AvatarGroup max={4} spacing="small">
            {contactsList.map(contactItem => <Avatar src={contactItem.profilePicUrl} />)}
          </AvatarGroup>

          <Typography
            onClick={handleOpenMultiVCardModal}
            className={classes.multiVCardInfo}
            variant="subtitle1"
            gutterBottom
          >
            {`${truncateString(contactsList[0].name, truncateThreshold)} ${i18n.t("multiVCard.texts.and")} ${contactsList.length - 1} ${i18n.t("multiVCard.texts.otherContacts")}`}
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <Divider />
          
          <Button
            fullWidth
            color="inherit"
            onClick={handleOpenMultiVCardModal}
          >
            {i18n.t("multiVCard.buttons.showCards")}
          </Button>
        </Grid>
      </Grid>
    </div>    
  );
};

export default MultiVcardPreview;